import { useCreditsQuery } from "../graphql/generated/graphql";
import { formatMoney } from "../i18n/formatNumbers";
import { useAppSettings } from "../providers/appSettingsProvider";

export const useRecommendedMonthlyBudget = () => {
  const { currency } = useAppSettings();
  const { data } = useCreditsQuery();

  const recommendedAmountNumber = data?.organization?.recommendedMonthlyBudget.amount || 3000;
  const recommendedMonthlyBudget = formatMoney({
    amount: recommendedAmountNumber,
    currency: data?.organization?.recommendedMonthlyBudget.currency || currency,
  });

  return {
    recommendedAmountNumber,
    recommendedMonthlyBudget,
  };
};
